<template>
    <section id="app-small-promo">
        <div class="row">
            <div class="col-sm-12 col-md order-md-1 order-2">
                <div class="row section-style-big-title">
                    <div class="col-auto">
                        <picture>
                            <img height="57" src="/assets/icons/app-color.svg" alt="Ultimate Jet Vacations App" />
                        </picture>
                    </div>
                    <div class="col-auto padding-right-left-0 margin-top-5">
                        <h2 class="bd-title font-weight-bold font-md">Ultimate Jet Vacations</h2>
                        <p class="font-sm">Free App</p>
                    </div>
                </div>
                <div class="section-style-big-description">
                    <p>
                        Specially curated to bring you inspiring ideas and insider knowledge, so you can experience the world's most exciting
                        destinations through our unrivalled concierge service.
                    </p>
                    <h3 class="font-md">Available in IOS and Android platforms.</h3>
                    <h3 class="font-md">Free download.</h3>
                </div>
                <div class="row section-style-big-btn">
                    <div class="col-12 col-xl-6">
                        <a href="https://itunes.apple.com/us/app/ultimate-jet-vacations/id1237770582?mt=8" target="_blank" role="button" aria-pressed="true" class="btn btn-light btn-lg w-100">
                            <img height="33" src="/assets/icons/app-store.svg" alt="Available on the App Store" />
                        </a>
                    </div>
                    <div class="col-12 col-xl-6">
                        <a href="http://play.google.com/store/apps/details?id=com.ujv.ujvar" target="_blank" role="button" aria-pressed="true" class="btn btn-light btn-lg w-100">
                            <img height="33" src="/assets/icons/google-play.svg" alt="Android App on Google Play" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 order-md-2 order-1">
                <div class="section-style-big-image">
                    <img class="mx-auto d-block" src="/assets/app/ujv-app.png" alt="Ultimate Jet Vacations App" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        mounted() {

        }
    }
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>